
import renderCategoryTree from './templates/factfinder-category-tree.tpl.html';

const EN = window.EN;
const EN_KO = window.EN_KO;

class FactfinderCategoryTree {

	constructor( containerEl ) {
		this.containerEl = containerEl;

		this.containerEl.addEventListener( 'click', ( ev ) => {
			const buttonEl = ev.target.closest( '.facet_menu__item_name' );
			if ( buttonEl ) {
				const menuItemEl = buttonEl.closest( '.facet_menu__item' );
				if ( menuItemEl.classList.contains( '.facet_menu__item--has_submenu' ) && ! menuItemEl.classList.contains( 'active_scope' ) ) {
					return;
				}

				if ( buttonEl.dataset.searchParams ) {
					const searchParams = JSON.parse( buttonEl.dataset.searchParams );
					this.containerEl.dispatchEvent( new CustomEvent( 'change.ff', { bubbles: true, detail: { searchParams } } ) );
				} else {
					this.onClick( buttonEl.dataset.path.split( '||' ) );
				}
			}
		} )
	}

	manipulateResponse( responseData ) {

		const { facets } = responseData;

		const CategoryPath = facets.find( ( facet ) => 'CategoryPath' === facet.associatedFieldName );
		const Categories = facets.find( ( facet ) => 'Categories' === facet.associatedFieldName );

		const nope = false;

		// Legacy Test, which sadly does not work.
		if ( Categories && nope ) {

			const tree = {};
			Categories.elements.forEach( ( element ) => {

				const path = [];
				let branch = tree;

				const catList = element.text.split( ' > ' );
				catList.forEach( ( cat, index ) => {
					path.push( cat );
					branch[ cat ] ??= {
						'clusterLevel': index,
						'text': cat,
						'path': path.join( '||' ),
						'selected': 'FALSE',
						'children': {},
					};
					branch = branch[ cat ][ 'children' ];
				} )
			} );

			const normalizeTree = ( children ) => {
				return Object.values( children ).map( child => {
					child.children = normalizeTree( child.children );
					return child;
				} );
			}

			CategoryPath.elements = normalizeTree( tree );
			console.log( responseData );
			return responseData;
		} else {
			return responseData;
		}
	}

	async update( {facets,searchParams} ) {
		this.searchParams = searchParams;

		const facet = facets.find( ( facet ) => 'CategoryPath' === facet.associatedFieldName );
		if ( facet ) {
			return Promise.all(
				this.getTree( facet.selectedElements, facet.elements ).map( ( node ) => {
					return EN.Render.render( 'factfinder-category-tree', { node, isOpen: false } );
				} )
			).then( ( renderedHTML ) => {
				this.containerEl.querySelector( '.facet_menu' ).innerHTML = renderedHTML.join( '' );
				EN_KO.functions.initFacetMenu();
			} );
		}
	}

	getTree( selectedElements, elements ) {

		const levels = [];
		const tree = [];

		let branch = tree;
		selectedElements.forEach( ( selectedElement ) => {
			const currentBranch = {
				...selectedElement,
				children: []
			};
			branch.push( currentBranch );
			levels.push( currentBranch );
			branch = currentBranch.children;
		} );

		elements.forEach( ( element ) => {
			const level = levels[ element.clusterLevel - 1 ]?.children ?? tree;
			level.push( element );
		} );

		levels.forEach( level => {
			level.children.sort( ( a, b ) => b.totalHits - a.totalHits );
		} );

		const fixedOrder = [ 'Damen', 'Herren', 'Kinder', 'Beauty', 'Home', 'Sportarten', 'Geschenke' ].toReversed();
		tree.sort( ( a, b ) => {
			const indexA = fixedOrder.indexOf( a.text );
			const indexB = fixedOrder.indexOf( b.text );
			return indexB - indexA;
		} );

		return tree;
	}

	onClick( path ) {

		const searchParams = { ...this.searchParams };
		const filterIndex =  ( searchParams.filters || [] ).findIndex( ( filter ) => filter.name === 'CategoryPath' );

		let pathFilter;
		if ( filterIndex === -1 ) {
			pathFilter = {
				name: 'CategoryPath',
				substring: false,
				values: []
			};
			searchParams.filters = [ ...( searchParams.filters || [] ), pathFilter ];
		} else {
			pathFilter = searchParams.filters[ filterIndex ];
		}

		pathFilter.values = [{
			exclude: false,
			type: 'or',
			value: path
		}];

		this.containerEl.dispatchEvent( new CustomEvent( 'change.ff', { bubbles: true, detail: { searchParams } } ) );
	}
}

EN.Render.addTemplate( 'factfinder-category-tree', renderCategoryTree );

export default FactfinderCategoryTree;
